// frontend/src/App.js
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import HomePage from "./pages/HomePage";
import UploadPage from "./pages/UploadPage";
import TransferUpload from "./pages/TransferUpload";
import DemoUpload from "./pages/DemoUpload";
import PrivateRoute from "./components/PrivateRoute";
import NotFound from "./components/NotFound";
import Compare from "./pages/Compare";
import Definitions from "./pages/Definitions";
import Guide from "./pages/Guide";
import About from "./pages/About";
import Events from "./pages/Events";
import Games from "./pages/Games";
import Players from "./pages/Players";
import SinglePlayer from "./pages/SinglePlayer";
import SingleEvent from "./pages/SingleEvent";
import SingleGame from "./pages/SingleGame";
import Watermark from "./components/Misc/Watermark";
import GameFootage from "./pages/GameFootage";
import RatingsFull from "./pages/RatingsFull";
import Portal from "./pages/Portal";
import PortalPlayer from "./pages/PortalPlayer";
import WomensHome from "./pages/womens/WHomePage";
import VerifyUser from "./components/Home/VerifyUser";
import ResendVerification from "./components/Home/ResendVerification";
import SplashScreen from "./pages/SplashScreen";
import NCAARatings from "./pages/NCAARatings";
import NBARatings from "./pages/NBARatings";
import NBADraft from "./pages/NBADraft";
import NBAFreeAgency from "./pages/NBAFreeAgency";
import AdminRoute from "./components/AdminRoute";
import AniCamp from "./pages/AniCamp";

function App() {
  const location = useLocation();
  const hideWatermark =
    [
      "/signup",
      "/login",
      "/verify",
      "/resend-verification",
      "/transfer-portal",
      "/ncaa",
      "/splash",
      "/ncaa-ratings",
      "/events",
      "/",
    ].includes(location.pathname) ||
    location.pathname.startsWith("/ncaa/") ||
    location.pathname.startsWith("/game/");

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify" element={<VerifyUser />} />
        <Route path="/resend-verification" element={<ResendVerification />} />
        <Route path="/" element={<SplashScreen />} />
        <Route path="/splash" element={<SplashScreen />} />
        {/* Private Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="/comparison" element={<Compare />} />
          <Route path="/definitions" element={<Definitions />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/about" element={<About />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/ani_camp" element={<AniCamp />} />
          <Route path="/games" element={<Games />} />
          <Route path="/players" element={<Players />} />
          <Route path="/player/:id" element={<SinglePlayer />} />
          <Route path="/event/:id" element={<SingleEvent />} />
          <Route path="/game/:id" element={<SingleGame />} />

          <Route path="/game-footage" element={<GameFootage />} />
          <Route path="/leaderboard" element={<RatingsFull />} />
          <Route path="/transfer-portal" element={<Portal />} />
          <Route path="/ncaa/:id" element={<PortalPlayer />} />
          <Route path="/ncaa-ratings" element={<NCAARatings />} />
          <Route path="/nba-ratings" element={<NBARatings />} />
          <Route path="/nba-draft" element={<NBADraft />} />
          <Route path="/nba-free-agency" element={<NBAFreeAgency />} />
          {/* Womens Basketball Routes */}
          <Route path="/womens/home" element={<WomensHome />} />
        </Route>

        {/* Admin Routes */}
        <Route element={<AdminRoute />}>
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/transfer-upload" element={<TransferUpload />} />
          <Route path="/demo-upload" element={<DemoUpload />} />
        </Route>

        {/* Catch-all Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideWatermark && <Watermark />}
    </>
  );
}

export default App;
